"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _colors = _interopRequireDefault(require("../../constants/colors"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var style = {
  button: function button(height, backgroundColor, hasBorder, hasShadow, isRounded, textColor) {
    return {
      width: '100%',
      height: height,
      backgroundColor: backgroundColor,
      border: hasBorder ? '2px solid #2d4bf2' : 'none',
      boxShadow: hasShadow ? '5px 20px 30px 0 rgba(0,0,0,0.1)' : 'none',
      fontWeight: 400,
      outline: 0,
      borderRadius: isRounded ? 100 : null,
      color: textColor,
      padding: '12px 24px'
    };
  }
};
var ButtonWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: ", ";\n    opacity: ", ";\n  }\n"])), function (_ref) {
  var isRounded = _ref.isRounded;
  return isRounded ? 'scale(0.95)' : 'scale(1)';
}, function (_ref2) {
  var isRounded = _ref2.isRounded;
  return isRounded ? '1' : '0.8';
});
var ButtonComponent = function ButtonComponent(props) {
  return /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    isRounded: props.isRounded,
    className: "buttonContainer"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: props.id || undefined,
    style: style.button(props.height, props.color, props.hasBorder, props.hasShadow, props.isRounded, props.textColor),
    type: props.type,
    disabled: props.disabled,
    onClick: props.onClick,
    "data-test": props.dataTest
  }, props.loading ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    color: "white",
    height: 17,
    width: 20
  })) : props.children));
};
ButtonComponent.propTypes = {
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  hasBorder: _propTypes["default"].bool,
  isRounded: _propTypes["default"].bool,
  hasShadow: _propTypes["default"].bool,
  textColor: _propTypes["default"].string,
  id: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired
};
ButtonComponent.defaultProps = {
  height: 50,
  color: _colors["default"].BUTTON_DEFAULT,
  hasBorder: false,
  isRounded: false,
  hasShadow: false,
  textColor: _colors["default"].WHITE,
  loading: undefined,
  id: undefined
};
var _default = exports["default"] = ButtonComponent;